import "./OrderConfirmation.css";

const categories = [
  {
    name: "Packages",
    image: "https://goodhand.b-cdn.net/Assets/packageslogo.svg",
    alt: "Packages",
  },
  {
    name: "Immigration",
    image:
      "https://goodhand.b-cdn.net/Assets/Web_Goodhand_imgs/Home_Page_Icons/fed.svg",
    alt: "Immigration Services",
  },
  {
    name: "Emirates ID",
    image:
      "https://goodhand.b-cdn.net/Assets/Web_Goodhand_imgs/Home_Page_Icons/sr2.svg",
    alt: "Emirates ID Services",
  },
  {
    name: "Tas-heel",
    image:
      "https://goodhand.b-cdn.net/Assets/Web_Goodhand_imgs/Home_Page_Icons/sr6.svg",
    alt: "Tasheel Services",
  },
  {
    name: "Taw-jeeh",
    image:
      "https://goodhand.b-cdn.net/Assets/Web_Goodhand_imgs/Home_Page_Icons/tawjeeh-logo-01.svg",
    alt: "Tawjeeh Services",
  },
  {
    name: "Dubai Health Authority",
    image:
      "https://goodhand.b-cdn.net/Assets/Web_Goodhand_imgs/Home_Page_Icons/sr4.svg",
    alt: "Dubai Health Authority",
  },
  {
    name: "Al Adheed",
    image:
      "https://goodhand.b-cdn.net/Assets/Web_Goodhand_imgs/Home_Page_Icons/adheeed.svg",
    alt: "Al Adheed Services",
  },
  {
    name: "Legal Translation",
    image:
      "https://goodhand.b-cdn.net/Assets/Web_Goodhand_imgs/Home_Page_Icons/sr8.svg",
    alt: "Legal Translation Services",
  },
];
const OrderConfirmation = () => {
  return (
    <div className="confirmation-container p-0">
      <div className="p-3 bg-2">
        <img
          src="https://www.goodhand.ae/assets/logo-main-gFDCiCbr.svg"
          className="logo"
          alt="Goodhand Logo"
        />
      </div>
      <div className="text-center p-3">
        <div className="py-3">
          <img
            src="https://goodhand.b-cdn.net/Assets/Flow/template-box-mail.svg"
            alt=""
          />
        </div>
        <h3 className="font-30">
          <strong>
            <em>Woohoo!</em>
          </strong>{" "}
          Your order is confirmed
        </h3>
        <p className="text-muted font-16 pt-3">
          Goodhand will start working on this right away. <br />
          We will notify you by email as soon as it is processed.
        </p>
      </div>

      {/* Timeline */}
      <div className="mail-timeline p-3">
        <div className="mail-step done">
          <div className="mail-circle"></div>
          <div className="mail-step-label">Ordered</div>
          <div className="mail-step-date">17 June 2025</div>
        </div>
        <div className="mail-step">
          <div className="mail-circle"></div>
          <div className="mail-step-label">Processing</div>
          <div className="mail-step-date">17 June 2025</div>
        </div>
        <div className="mail-step">
          <div className="mail-circle"></div>
          <div className="mail-step-label">Expected Time to Finish</div>
          <div className="mail-step-date">2 Weeks</div>
        </div>
      </div>

      <div className="text-center m-4 border-bottom">
        <a href="#" className="btn btn-primary rounded-pill view-order-btn">
          View Your Order
        </a>
      </div>

      <div className="px-4">
        <div className="text-center ff-regular font-18 pb-3">
          <h5 className="">Please check your order detail</h5>
        </div>
        <div className="layout-border p-3 rounded-3">
          {[1, 2, 3].map((_, idx) => (
            <div className="order-item" key={idx}>
              <img
                src="https://goodhand.b-cdn.net/Assets/Web_Goodhand_imgs/Goodhand_images_amer/Son%20Or%20Daughter%20Sponsor%20Investor%20or%20Partner%20dxb%20residenc.webp"
                alt="Service"
              />
              <div>
                <div className="font-13 text-muted">Service</div>
                <div className="text-black font-16 ff-medium">
                  Son / Daughter Residence Visa
                </div>
                <div className="text-black font-16 ff-medium">Qty: 1</div>
              </div>
              <div className="ms-auto font-16 ff-semibold">AED 469</div>
            </div>
          ))}

          <div className="p-4 pt-2">
            {[
              ["Actual Price", "AED 500.00"],
              ["Item total", "AED 450.00"],
              ["Discount", "AED 50.00"],
              ["Visitation Fee", "AED 20.00"],
              ["Handling Fee", "AED 15.00"],
              ["Convenience Fee", "AED 10.00"],
              ["Tip", "AED 10.00"],
            ].map(([label, value], idx) => (
              <div className="payment-summary-item" key={idx}>
                <div className="d-flex justify-content-between">
                  <p className="payment-summary-label">{label}</p>
                  <p className="payment-summary-value">{value}</p>
                </div>
              </div>
            ))}

            <div className="payment-summary-item pt-3">
              <div className="d-flex justify-content-between">
                <p className="font-14 text-black ff-bold mb-0">Paid</p>
                <p className="font-14 text-black ff-bold mb-0">AED 420.00</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="support-box m-4 bg-3 rounded-4">
        <h3 className="support-title">Need further help?</h3>
        <p className="support-subtext">
          Contact our friendly Customer Service team - remember we'll need your
          order.
        </p>

        <div className="support-options">
          <div className="support-item">
            <img
              src="https://goodhand.b-cdn.net/Assets/Flow/envlp-mail.svg"
              alt=""
            />
            <p>Click here to send us an email</p>
          </div>
          <div className="support-item">
            <img
              src="https://goodhand.b-cdn.net/Assets/Flow/whtsp-mail.svg"
              alt=""
            />
            <p>
              <strong>+971 123 4567</strong>
              <br />
              <span>( Reach us on WhatsApp )</span>
            </p>
          </div>
          <div className="support-item">
            <img
              src="https://goodhand.b-cdn.net/Assets/Flow/phone-mail.svg"
              alt=""
            />
            <p>
              <strong>+971 123 4567</strong>
              <br />
              <span>Mon to Sat 9:00 am to 6:00 pm</span>
            </p>
          </div>
        </div>
      </div>

      <div className="text-center mt-4 d-flex justify-content-center gap-2 ft-icons-mail-wrap">
        <div className="footer-icons-mail">
          <a href="#">
            <i className="fab fa-facebook-f"></i>
          </a>
        </div>
        <div className="footer-icons-mail">
          <a href="#">
            <i className="fab fa-instagram"></i>
          </a>
        </div>
        <div className="footer-icons-mail">
          <a href="#">
            <i className="fab fa-twitter"></i>
          </a>
        </div>
        <div className="footer-icons-mail">
          <a href="#">
            <i className="fab fa-youtube"></i>
          </a>
        </div>
        <div className="footer-icons-mail">
          <a href="#">
            <i className="fab fa-whatsapp"></i>
          </a>
        </div>
        <div className="footer-icons-mail">
          <a href="#">
            <i className="fab fa-linkedin-in"></i>
          </a>
        </div>
      </div>

      <p className="text-center text-muted mt-4 note-text">
        This inbox is not attended so please don’t reply to this email. This is
        a service email. You will receive these no matter what your marketing
        communication preferences are.
      </p>
      <div className="grid-wrapper mail-any">
        {categories.map((item, idx) => (
          <div key={idx} className="icon-box-wrap">
            <div className="icon-box">
              <img src={item.image} alt={item.alt} loading="lazy" />
            </div>
            <div className="icon-title">{item.name}</div>
          </div>
        ))}
      </div>
      <div className="text-center mt-3">
        <p>
          <strong>
            Thanks,
            <br />
            Goodhand team
          </strong>
        </p>
      </div>
    </div>
  );
};

export default OrderConfirmation;
